import { Component, Input } from '@angular/core';

let nextId = 0;

// Puts a label (with optional required marker) above a projected control and an optional
// hint below it. Works with plain mat-form-fields and the shared field components.
// Reference labelId (via a template ref) for aria-labelledby on controls without a native label.
@Component({
    selector: 'app-labeled-field',
    templateUrl: './labeled-field.component.html',
    styleUrl: './labeled-field.component.scss',
    host: {
        '[class.full-width]': 'fullWidth'
    }
})
export class LabeledFieldComponent {
  @Input({ required: true }) label = '';
  @Input() required = false;
  @Input() hint = '';
  @Input() fullWidth = false;

  readonly labelId = `labeled-field-label-${nextId++}`;
}
